var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorialBgCornerTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10H10V0C10 5.52285 5.52285 10 0 10Z",
    fill: "#081B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialBgCornerTop);
export default __webpack_public_path__ + "static/media/tutorialBgCornerTop.f1fd6837f2c1b8a514490fcadc4d6572.svg";
export { ForwardRef as ReactComponent };